/* eslint-disable */
export default {
  monday: 'M',
  tuesday: 'T',
  wednesday: 'W',
  thursday: 'T',
  friday: 'F',
  saturday: 'S',
  sunday: 'S',
} as const;

// @key: @#@"monday"@#@ @source: @#@"M"@#@
// @key: @#@"tuesday"@#@ @source: @#@"T"@#@
// @key: @#@"wednesday"@#@ @source: @#@"W"@#@
// @key: @#@"thursday"@#@ @source: @#@"T"@#@
// @key: @#@"friday"@#@ @source: @#@"F"@#@
// @key: @#@"saturday"@#@ @source: @#@"S"@#@
// @key: @#@"sunday"@#@ @source: @#@"S"@#@
